export interface ITagOverflow {
  visibleCount: number
  isOverflowing: boolean
}

function rowsUsed(
  widths: number[],
  containerWidth: number,
  gap: number,
): number {
  let rows = 1
  let lineWidth = 0
  for (const width of widths) {
    if (lineWidth === 0) {
      lineWidth = width
    } else if (lineWidth + gap + width <= containerWidth) {
      lineWidth += gap + width
    } else {
      rows += 1
      lineWidth = width
    }
  }
  return rows
}

export function computeVisibleTagCount(
  tagWidths: number[],
  containerWidth: number,
  gap: number,
  maxRows: number,
  toggleWidth: number,
): ITagOverflow {
  const total = tagWidths.length
  if (total === 0 || maxRows < 1 || containerWidth <= 0) {
    return { visibleCount: total, isOverflowing: false }
  }

  if (rowsUsed(tagWidths, containerWidth, gap) <= maxRows) {
    return { visibleCount: total, isOverflowing: false }
  }

  // Overflowing: single forward pass packing tags left-to-right, tracking the
  // largest leading count whose tags + the trailing "+n more" toggle still fit
  // within maxRows. The toggle goes last, so its row only depends on the line
  // width after the last placed tag — O(1) to check per step → O(n) overall.
  let rows = 1
  let lineWidth = 0
  let visibleCount = 0
  for (let i = 0; i < total; i++) {
    const width = tagWidths[i]
    if (lineWidth === 0) {
      lineWidth = width
    } else if (lineWidth + gap + width <= containerWidth) {
      lineWidth += gap + width
    } else {
      rows += 1
      lineWidth = width
    }
    if (rows > maxRows) break
    const toggleRows =
      lineWidth + gap + toggleWidth <= containerWidth ? rows : rows + 1
    if (toggleRows <= maxRows) visibleCount = i + 1
  }

  return { visibleCount, isOverflowing: true }
}
